// @flow
import * as React from 'react'
import { isEmpty } from 'er2_web_utils'
import GeoBarPanel from '../components/geo_bar_panel'
import { isGeoBarActive } from '../reducers/geo_bar'
import type { GeoBarType } from '../reducers/geo_bar'

type Props = {
    actions: object,
    children: object,
    geoBar?: GeoBarType,
    olMap: object,
    mapToolbar: { // eslint-disable-line react/no-unused-prop-types
        isContracted: boolean,
    },
    theme: { // eslint-disable-line react/no-unused-prop-types
        mapToolbarPanel: string,
        selectedStation: string,
        titleBar: string,
    },
    mapsources: {},
    token: {
        value: string,
        expires: number,
    },
}

function generateClassNames(props) {
    // Use the given theme if provided (don't try to merge,
    // since there's no guarantee the styles were build with Aphrodite)
    return `${props.theme.mapToolbarPanel} ${props.mapToolbar.isContracted ? props.theme.contracted : ''}`
}

class MapToolbarPanel extends React.Component<Props> {
    renderGeoBar() {
        const geoBarActive = this.props.geoBar && this.props.geoBar.active
        const active = isGeoBarActive({ mapToolbar: this.props.mapToolbar }, geoBarActive)
        if (active) {
            return (<GeoBarPanel
                actions={this.props.actions}
                geoBar={this.props.geoBar}
                olMap={this.props.olMap}
                mapsources={this.props.mapsources}
                theme={this.props.theme}
                token={this.props.token}
            />)
        }
        return (null)
    }

    render() {
        const classNames = generateClassNames(this.props)
        return (
            <div className={classNames} >
                {this.props.children}
                {this.renderGeoBar()}
            </div>
        )
    }
}

export default MapToolbarPanel
